import PropTypes from "prop-types"

import IngredientTextField from "shared/components/stored_fields/ingredient_text_field/index"

export default function StencilField({
  fieldName,
  ingredientsMetadata,
  stencil,
}) {
  return (
    <div className="field">
      <div className="label">
        <label htmlFor="partner_trigger_field_name">{stencil.label}</label>
      </div>

      <div className="input">
        <IngredientTextField
          ingredientsMetadata={ingredientsMetadata}
          fieldName={fieldName}
          name={stencil.slug}
          note={stencil.note}
          value={stencil.value}
        />
      </div>
    </div>
  )
}

StencilField.propTypes = {
  fieldName: PropTypes.string,
  ingredientsMetadata: PropTypes.object,
  stencil: PropTypes.object,
}
